module.exports = __webpack_public_path__ + "img/upload-folder.3973818e.svg";